/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MenuItemList
 */
export interface MenuItemList {
    /**
     * 
     * @type {number}
     * @memberof MenuItemList
     */
    readonly id: number;
    /**
     * 
     * @type {string}
     * @memberof MenuItemList
     */
    readonly business_id: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemList
     */
    name: string;
    /**
     * This item's index within its category.
     * @type {number}
     * @memberof MenuItemList
     */
    index: number;
    /**
     * 
     * @type {string}
     * @memberof MenuItemList
     */
    description?: string;
    /**
     * The lowest variant price of this item. Displayed as $X.XX+ if there are multiple variants.
     * @type {string}
     * @memberof MenuItemList
     */
    price: string;
    /**
     * 
     * @type {string}
     * @memberof MenuItemList
     */
    readonly image: string;
}

/**
 * Check if a given object implements the MenuItemList interface.
 */
export function instanceOfMenuItemList(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "business_id" in value;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "index" in value;
    isInstance = isInstance && "price" in value;
    isInstance = isInstance && "image" in value;

    return isInstance;
}

export function MenuItemListFromJSON(json: any): MenuItemList {
    return MenuItemListFromJSONTyped(json, false);
}

export function MenuItemListFromJSONTyped(json: any, ignoreDiscriminator: boolean): MenuItemList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'business_id': json['business_id'],
        'name': json['name'],
        'index': json['index'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'price': json['price'],
        'image': json['image'],
    };
}

export function MenuItemListToJSON(value?: MenuItemList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'index': value.index,
        'description': value.description,
        'price': value.price,
    };
}

